import React from 'react';
import PropTypes from 'prop-types';
import { UserContext } from '../../../hoc/User';
import { EditorWizardContext } from '../../../hoc/EditorWizard';
import NextButton from '../nextStepButton';
import styles from './styles.less';

const StepContainer = ({
  children,
  nextButtonDisabled,
  stepClassName = '',
  nextButtonNotPassed = false,
}) => {
  const { user } = React.useContext(UserContext);
  const { step, nextStep, previousStep } = React.useContext(EditorWizardContext);
  return (
    <div className={styles.container}>
      <div className={styles.section_wizard_individual}>
        <div className={step > 0 ? styles.flexiable_container : styles.flexibleTerms}>
          <div className={styles.center}>
            <div>{children}</div>
          </div>
        </div>
      </div>
      <NextButton
        disabled={nextButtonDisabled || !user}
        notPassed={nextButtonNotPassed}
        nextStep={nextStep}
        previousStep={previousStep}
        step={step}
        stepClassName={stepClassName}
      />
    </div>
  );
};

StepContainer.propTypes = {
  nextButtonDisabled: PropTypes.bool.isRequired,
  nextButtonNotPassed: PropTypes.bool,
  stepClassName: PropTypes.string,
  children: PropTypes.node.isRequired,
};

StepContainer.defaultProps = {
  nextButtonNotPassed: false,
  stepClassName: '',
};

export default StepContainer;
